export default "__VITE_ASSET__IIbQ5w_tU2ENF4MI12kVqg__";